module.exports = __webpack_public_path__ + "img/couples-003.5e1f798c.jpg";